import React from "react";
import {Button, Modal} from "react-bootstrap";
import CreateList from "./CreateList";
import {clientEmailAllowedCreate} from "api";

class CreateModal extends React.Component {
    state = {
        emails: [
            '',
        ],
    };

    constructor(props, context) {
        super(props, context);

        this.handleCreate = this.handleCreate.bind(this);
        this.handleDeleteEmail = this.handleDeleteEmail.bind(this);
        this.handleChangeEmail = this.handleChangeEmail.bind(this);
    }

    handleCreate() {
        const {event, onCreate} = this.props;
        const {emails} = this.state;

        clientEmailAllowedCreate(event.eventPassword, emails)
            .then(onCreate);
    }

    handleChangeEmail(oldEmail, newEmail) {
        let {emails} = this.state;
        const index = this.state.emails.findIndex(email => email === oldEmail);

        if (index >= 0) {
            emails[index] = newEmail;
            this.setState({emails});
        }
    }

    handleDeleteEmail(email) {
        const emails = this.state.emails.slice();
        const index = emails.findIndex(item => item === email);
        if (index >= 0) {
            emails.splice(index, 1);
            this.setState({emails});
        }
    }

    render() {
        const {show, onHide} = this.props;
        const {emails} = this.state;

        return (
            <Modal show={show} onHide={onHide} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Добавление электронной почты</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CreateList
                        emails={emails}
                        onChange={this.handleChangeEmail}
                        onDelete={this.handleDeleteEmail}
                    />
                    <Button onClick={() => this.setState({emails: [...emails, '']})}>
                        Добавить
                    </Button>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        bsStyle="primary"
                        onClick={this.handleCreate}
                    >
                        Создать
                    </Button>
                    <Button
                        onClick={onHide}
                    >
                        Закрыть
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default CreateModal;
